import React from 'react'

import DatesFilter from './DatesFilter'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'
import ServiceOrderFiltersList from '../../../../containers/serviceOrders/filters/ServiceOrderFiltersList'

const FiltersBar = ({ open, hideDateFilters }) => {
  return (
    <ScreenViewFilterBar screen="service_orders" open={open}>
      <ServiceOrderFiltersList />
      {!hideDateFilters && <DatesFilter />}
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
